"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgreementV2 = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = require("../Link");
var styles = _interopRequireWildcard(require("./AgreementV2.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AgreementV2 = _ref => {
  let {
    agreementAccepted,
    subscriptionAccepted,
    onAgreementChange,
    onSubscriptionChange,
    cianHost
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['row--first'], styles[`row--first--${deviceType}`]),
    "data-testid": "row-first",
    "data-name": "advertisingMailingsAgreement"
  }, /*#__PURE__*/React.createElement(_uiKit.Checkbox, {
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\xA0\u0441\u043A\u0438\u0434\u043A\u0438, \u0441\u043E\u0432\u0435\u0442\u044B \u043F\u043E\xA0\u043F\u043E\u0435\u0437\u0434\u043A\u0430\u043C \u0438\xA0\u0434\u0440\u0443\u0433\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B\xA0\u2014", /*#__PURE__*/React.createElement(_Link.Link, {
      href: `${cianHost}/legal-documents/soglasie_na_poluchenie_reklamnyx_rassylok_0`,
      target: "_blank",
      responsive: true
    }, "\u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435")),
    checked: subscriptionAccepted,
    onChange: onSubscriptionChange
  })), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['row--second'], styles[`row--second--${deviceType}`]),
    "data-testid": "row-second",
    "data-name": "userAgreement"
  }, /*#__PURE__*/React.createElement(_uiKit.Checkbox, {
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "\u041F\u0440\u0438\u043D\u0438\u043C\u0430\u044E \u0443\u0441\u043B\u043E\u0432\u0438\u044F", ' ', /*#__PURE__*/React.createElement(_Link.Link, {
      href: `${cianHost}/help/about/rules/`,
      target: "_blank",
      responsive: true
    }, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F"), ",", ' ', /*#__PURE__*/React.createElement(_Link.Link, {
      href: `${cianHost}/help/about/36526/`,
      target: "_blank",
      responsive: true
    }, "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438"), ' ', "\u0438\xA0", /*#__PURE__*/React.createElement(_Link.Link, {
      href: `${cianHost}/legal-documents/soglasie_na_obrabotku_personalnyx_dannyx_razreshennyx_subektom_personalnyx_dannyx_dlya_rasprostraneniya_0`,
      target: "_blank",
      responsive: true
    }, "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0438\xA0\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445")),
    checked: agreementAccepted,
    onChange: onAgreementChange
  })));
};
exports.AgreementV2 = AgreementV2;